/*
 * Plays the clips only while they are on screen.
 *
 * Four autoplaying videos in a row is an easy way to make a page crawl on a
 * phone: every one of them starts buffering the moment the markup parses,
 * whether or not the customer will ever scroll that far. So they ship with
 * `preload="none"` and nothing to play, and the source is attached the first
 * time the tile comes into view.
 */

(() => {
  const START = 0.35; // on screen enough to be worth playing
  const grids = document.querySelectorAll('.social-videos__grid');
  if (!grids.length) return;

  const wantsStillness = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (!entry.isIntersecting) {
          if (!video.paused) video.pause();
          return;
        }

        // The <source> is held back until now so nothing downloads early.
        if (video.dataset.armed !== 'true') {
          video.dataset.armed = 'true';
          video.preload = 'auto';
          video.load();
        }
        if (wantsStillness) return;

        const attempt = video.play();
        // Autoplay can still be refused — a low-power phone, a browser setting.
        // The poster stays up, which is a perfectly good outcome.
        if (attempt && attempt.catch) attempt.catch(() => {});
      });
    },
    { threshold: START }
  );

  grids.forEach((grid) => {
    grid.querySelectorAll('video').forEach((video) => {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');
      observer.observe(video);
    });
  });
})();
